module.exports = __webpack_public_path__ + "media/images/emoticons/impact-383c3a4bf4304aa55e93cbbbcdd02186.gif";